import { FC, useEffect, useState } from 'react'
import { IMGs } from '../../../../assets/img'
import Styles from './Tiers.module.scss'
import { Tier } from './Tier'
import { useAppDispatch, useAppSelector } from '../../../../app/hook'
import { BitazzaModal, BitazzaText, Spinner } from '../../../../components'
import { useTranslation } from 'react-i18next'
import { fetchNftDetail } from '../../../LeaderBoard/leaderBoardSlice'
import { NftDetail } from './NftDetail'

type nft = {
    amount: number
    detail: string
    rank: string
    reward_id: number
    type: string
}

interface PropsTiers {
    img: string
    maxDes: string
    des: string
    min: string
    label: string
    src: string
    title: string
    nft: nft[]
    prize?: boolean
}

interface Props {
    noMargin?: boolean
    region: 'th' | 'gl'
}
export const Tiers: FC<Props> = ({ noMargin, region }) => {
    const { t } = useTranslation()
    const dispatch = useAppDispatch()
    const [tiers, setTiers] = useState<any>([])
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
    const { season, nftDetail } = useAppSelector((state) => state.leaderBoard)

    useEffect(() => {
        setTiers([
            {
                img: IMGs.tierGrandMasterSvg,
                title: 'GRAND MASTER',
                maxDes: t('txt_max_50'),
                des: t('txt_top_1_challengers'),
                min: t('txt_min_pnl30'),
                label: 'Grand-Master',
                //@ts-ignore
                nft: season?.ranking_rewards?.filter(
                    (a) => a.rank === 'Grand-Master'
                ),
                prize: season?.ranking_rewards?.filter(
                    (a) => a.rank === 'Grand-Master'
                ).length,
            },
            {
                img: IMGs.tierMasterSvg,
                title: 'MASTER',
                des: t('txt_top_10_challengers'),
                min: t('txt_min_pnl20'),
                label: 'Master',
                //@ts-ignore
                nft: season?.ranking_rewards?.filter(
                    (a) => a.rank === 'Master'
                ),
                prize: season?.ranking_rewards?.filter(
                    (a) => a.rank === 'Master'
                ).length,
            },

            {
                img: IMGs.tierDiamondSvg,
                title: 'DIAMOND',
                des: t('txt_top_25_challengers'),
                min: t('txt_min_pnl10'),
                label: 'Diamond',
                nft: season?.ranking_rewards?.filter(
                    (a) => a.rank === 'Diamond'
                ),
                prize: season?.ranking_rewards?.filter(
                    (a) => a.rank === 'Diamond'
                ).length,
            },
            {
                img: IMGs.tierGoldSvg,
                title: 'GOLD',
                des: t('txt_top_50_challengers'),
                min: t('txt_min_pnl0'),
                label: 'Gold',
                nft: season?.ranking_rewards?.filter((a) => a.rank === 'Gold'),
                prize: season?.ranking_rewards?.filter((a) => a.rank === 'Gold')
                    .length,
            },

            {
                img: IMGs.tierSilverSvg,
                title: 'SILVER',
                des: t('txt_top_75_challengers'),
                min: t('txt_no_min_required'),
                label: 'Silver',
                nft: season?.ranking_rewards?.filter(
                    (a) => a.rank === 'Silver'
                ),
                prize: season?.ranking_rewards?.filter(
                    (a) => a.rank === 'Silver'
                ).length,
            },
            {
                img: IMGs.tierBronzeSvg,
                title: 'BRONZE',
                min: t('txt_no_min_required'),
                label: 'Bronze',
                nft: season?.ranking_rewards?.filter(
                    (a) => a.rank === 'Bronze'
                ),
                prize: season?.ranking_rewards?.filter(
                    (a) => a.rank === 'Bronze'
                ).length,
            },
        ])
    }, [season])

    if (!season) {
        return <Spinner />
    }

    const nftDetailHandler = (nftId: number) => {
        dispatch(fetchNftDetail(nftId.toString())).then(() =>
            setIsModalOpen(true)
        )
    }

    return (
        <div style={{ marginBottom: noMargin ? '10px' : '100px' }}>
            <BitazzaModal
                size="100%"
                footer={
                    <div
                        className={Styles.button}
                        onClick={() => setIsModalOpen(false)}
                    >
                        <BitazzaText
                            format="t18"
                            color="#FFF"
                            content="Close"
                            bold
                        />
                    </div>
                }
                onCancel={() => setIsModalOpen(false)}
                isModalOpen={isModalOpen}
            >
                <NftDetail
                    name={nftDetail?.name}
                    description={nftDetail?.description}
                    image={nftDetail?.image}
                    benefits={nftDetail?.benefits}
                />
            </BitazzaModal>
            {tiers?.map((tier: PropsTiers, index: number) => {
                return (
                    <div className={Styles.wrapper} key={index}>
                        <div className={Styles.wrapperDiv}>
                            <Tier
                                img={tier.img}
                                title={tier.title}
                                maxDes={tier.maxDes}
                                des={tier.des}
                                min={tier.min}
                            />
                        </div>

                        {tier.prize ? (
                            <div className={Styles.nftContainer}>
                                <BitazzaText
                                    content={'NFT Prize'}
                                    color="#86A1A1"
                                    format="t14"
                                    noWrap
                                />
                                <div className={Styles.nftWrapper}>
                                    {tier?.nft?.map((item) => {
                                        return (
                                            <img
                                                style={{
                                                    width: '45px',
                                                    objectFit: 'contain',
                                                    height: 'auto',
                                                }}
                                                src={item.detail}
                                                alt="nftDetail"
                                                onClick={() =>
                                                    nftDetailHandler(
                                                        item.reward_id
                                                    )
                                                }
                                            />
                                        )
                                    })}
                                </div>
                            </div>
                        ) : null}
                    </div>
                )
            })}
        </div>
    )
}
